/**
 * This file re-exports backend types for use in the frontend
 * It provides type safety by ensuring frontend types match backend types exactly
 */

/**
 * Payment plan status enum from the backend
 */
export enum PaymentPlanStatusEnum {
  /** The instalment schedule has not been created/started */
  notStarted = 'not-started',

  /** The instalment schedule is active, more instalments will be scheduled */
  active = 'active',

  /** The instalment schedule has completed, all instalments have been paid */
  completed = 'completed',

  /** The instalment schedule has been cancelled, no further instalments will be scheduled */
  cancelled = 'cancelled',

  /** The instalment schedule has been stopped, no further instalments will be scheduled */
  stopped = 'stopped',

  /** The instalment schedule has been suspended, no further instalments will be processed */
  suspended = 'suspended',
}

/**
 * Utility functions for working with payment plan statuses
 */
export const isSuspended = (status: PaymentPlanStatusEnum): boolean => {
  return status === PaymentPlanStatusEnum.suspended
}

export const isActive = (status: PaymentPlanStatusEnum): boolean => {
  return status === PaymentPlanStatusEnum.active
}

export const isTerminal = (status: string): boolean => {
  return (
    status === PaymentPlanStatusEnum.completed ||
    status === PaymentPlanStatusEnum.cancelled ||
    status === PaymentPlanStatusEnum.stopped
  )
}
